/**
 * Handler for Dynamic Google Enhanced Ecommerced tracking
 */
class EnhancedEcommerceTracker {
    /**
     * @param {TrackingAnalytics} analytics
     */
    constructor(analytics) {
        this.analytics = analytics;
    }

    /**
     * @returns {EnhancedEcommerceTracker}
     */
    init() {
        if (!window.GADATA) {
            return this;
        }

        this.promotions = window.GADATA.promotions;
        this.impressions = window.GADATA.impressions;
        this.products = window.GADATA.products;

        this.setUpClicks();

        return this;
    }

    /**
     * @returns {EnhancedEcommerceTracker}
     */
    setUpClicks() {
        this.setUpImpressions()
            .setUpPromotions();

        return this;
    }

    /**
     * @returns {EnhancedEcommerceTracker}
     */
    setUpImpressions() {
        if (this.impressions === null || typeof this.impressions !== 'object') {
            return this;
        }

        let ids = Object.keys(this.impressions);
        ids.forEach((id) => {
            if (id && '' !== id.trim()) {
                var $product = $('#' + id);
                var productIndex = ($product.index() || 0) + 1;
                this.bindProductClick($product.find('a.detail-url'), this.impressions[id], 'Catalog item - ' + productIndex);
            }
        });

        return this;
    }

    /**
     * @returns {EnhancedEcommerceTracker}
     */
    setUpPromotions() {
        if (this.promotions === null || typeof this.promotions !== 'object') {
            return this;
        }

        let ids = Object.keys(this.promotions);

        ids.forEach((id) => {
            if (id && '' !== id.trim()) {
                var $product, $target, promotionType, productIndex, eventLabel;
                $product = $('#' + id);
                $target = $product.find('a');
                promotionType = this.getPromotionType($product);
                productIndex = ($product.index() || 0) + 1;
                eventLabel = promotionType + ' - ' + productIndex;

                this.bindPromotionClick($target, this.promotions[id], eventLabel);
                this.bindProductClick($target, this.impressions[this.promotions[id].name], eventLabel);
            }
        });

        return this;
    }

    /**
     *
     * @param $product
     * @returns string
     */
    getPromotionType($product) {
        var containerIndex = $product.parents('.promotion-set').index();

        switch (containerIndex) {
            case 0:
                return 'Premium';
            case 1:
                return 'Mid-Range';
            case 2:
                return 'Budget';
            default:
                return '';
        }
    }

    /**
     *
     * @param $product
     * @param object
     * @param eventLabel
     */
    bindProductClick($product, object, eventLabel) {
        $product.on('click', this.handleProductClick.bind(this, object, $product.attr('href'), eventLabel));
    }

    /**
     *
     * @param $product
     * @param object
     * @param eventLabel
     */
    bindPromotionClick($product, object, eventLabel) {
        $product.on('click', this.handlePromotionClick.bind(this, object, $product.attr('href'), eventLabel));
    }

    /**
     * @param {Object} product
     * @param {String} redirect
     * @param {jQuery.Event} event
     */
    handleItemClick(product, redirect, event) {
        event.preventDefault();

        this.analytics.setEcommerceProduct(product);
        this.analytics.setEcommerceAction('click', { list: 'catalog' });
        this.analytics.trackWithCallback(
            {
                eventName: 'product',
                eventBody: {
                    event_category: 'click',
                }
            },
            EnhancedEcommerceTracker.redirect.bind(this, redirect)
        );
    }

    /**
     *
     * @param product
     * @param redirect
     * @param eventLabel
     * @param event
     */
    handleProductClick(product, redirect, eventLabel, event) {
        event.preventDefault();

        this.analytics.setEcommerceProduct(product);
        this.analytics.setEcommerceAction('click', { list: product.list });
        this.analytics.trackWithCallback(
            {
                eventName: 'product',
                eventBody: {
                    event_category: 'click',
                    event_label: eventLabel
                }
            },
            EnhancedEcommerceTracker.redirect.bind(this, redirect)
        );


    }

    /**
     *
     * @param product
     * @param redirect
     * @param eventLabel
     * @param event
     */
    handlePromotionClick(product, redirect, eventLabel, event) {
        event.preventDefault();

        this.analytics.setEcommercePromotion(product);
        this.analytics.setEcommerceAction('promo_click', { list: GADATA.impressions[product.name].list });
        this.analytics.trackWithCallback(
            {
                eventName: 'promotion',
                eventBody: {
                    event_category: 'click',
                    event_label: eventLabel
                }
            },
            EnhancedEcommerceTracker.redirect.bind(this, redirect)
        );
    }

    /**
     * @param  {String} url
     */
    static redirect(url) {
        window.location = url;
    }
}

export default EnhancedEcommerceTracker;